import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./ChatWorkspace.module.scss";
import agent2 from "./agent-2.gif";

export default function FlashAssistant() {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/ai-chat") {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.abyssLauncher}
      onClick={() => navigate("/ai-chat")}
      aria-label="Open AI Assistant"
    >
      <span className={styles.abyssLauncherWrap}>
        <span className={styles.abyssLauncherLabel}>Ask AI</span>
        <span className={styles.abyssLauncherOrbWrap}>
          <span className={styles.abyssLauncherCircle}>
            <img
              src={agent2}
              alt="AI Assistant"
              className={styles.abyssLauncherImg}
            />
          </span>
        </span>
      </span>
    </button>
  );
}
